import React, {Component} from 'react';
import Parser from 'html-react-parser';
import { render } from 'react-dom';
import {  isBrowser, isMobile} from "react-device-detect";
import axios from "axios/index";

class SearchDetailContent extends Component{
    constructor(props){
        super(props);

        this.state = {
            share: true,
        }

        this.togshare = this.togshare.bind(this);

    }
    componentDidMount(){
        window.scrollTo(0,0);
    }

    togshare(){
        this.setState({
            share: !this.state.share,
        })
    }

    setit(id){

        var array = new Array();
        array.push(id);
        array.push(1);

        this.props.setSearchDefs(array);
    }

    setittag(id){

        var array = new Array();
        array.push(id);
        array.push(1);
        array.push(2);
        this.props.setSearchDefs(array);
    }

    render(){
        return(
            <div className="searchdetailcontent">
                <div className="container">
                    <div className="row odsunCont">
                        <div className="col-lg-8">
                            <div className="card">
                                <div className="card-header popis">
                                    <a className="card-link" data-toggle="collapse" href="#collapseOne">
                                        <i className="far fa-sticky-note"></i>Popis
                                    </a>
                                </div>
                                <div id="collapseOne" className="collapse show" data-parent="#accordion">
                                    <div className="card-body">
                                        <Description ide={this.props.ide}/>
                                    </div>
                                </div>
                            </div>
                            <div id="accordion">

                                { isMobile ? (
                                <div className="card">
                                    <div className="card-header">
                                        <a className="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
                                            <i className="fa fa-align-left"></i>Akcie
                                        </a>
                                    </div>
                                    <div id="collapseTwo" className="collapse" data-parent="#accordion">
                                        <div className="card-body">

                                            <Offers ide={this.props.ide}/>


                                              </div>
                                    </div>
                                </div>
                                ): (
                                    <div className="card">
                                        <div className="card-header">
                                            <a className="collapsed card-link" href="https://www.apportal.sk/akcie">
                                                <i className="fa fa-align-left"></i>Akcie
                                            </a>
                                        </div>
                                    </div>
                                )}

                                <div className="card">
                                    <div className="card-header">
                                        <a className="collapsed card-link" data-toggle="collapse" href="#collapseThree">
                                            <i className="fas fa-calendar-alt"></i>Otvarácie hodiny
                                        </a>
                                    </div>
                                    <div id="collapseThree" className="collapse" data-parent="#accordion">
                                        <div className="card-body">
                                            <OpenHours ide={this.props.ide} />
                                              </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <a className="collapsed card-link" data-toggle="collapse" href="#collapseFour">
                                            <i class="fa fa-map"></i>Mapa
                                        </a>
                                    </div>
                                    <div id="collapseFour" className="collapse" data-parent="#accordion">
                                        <div className="card-body">

                                            { Parser(this.props.result.map.toString()) }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">
                                {/*<div class="sidebar_wrap listing_action_btn">*/}
                                    {/*<div className="row">*/}
                                        {/*<div className="col-md-6 cont">*/}
                                            {/*<div className="boxik">*/}
                                                {/*<a data-toggle="modal" data-target="#share_modal"><i className="fa fa-share-alt"></i>Zdieľať </a>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-6 cont">*/}
                                            {/*<div className="boxik">*/}
                                                {/*<a data-toggle="modal" data-target="#share_modal"><i className="fa far fa-envelope"></i>E-mail priateľom </a>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-6 cont">*/}
                                            {/*<div className="boxik">*/}
                                                {/*<a data-toggle="modal" data-target="#share_modal"><i className="fa fa-star"></i>Pridať recenziu </a>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-6 cont">*/}
                                            {/*<div className="boxik">*/}
                                                {/*<a data-toggle="modal" data-target="#share_modal"><i className="fa fa-exclamation-triangle"></i>Nahlásiť </a>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}

                                {/*</div>*/}

                                {/*<hr/>*/}
                                <h6 className="kontakt">
                                    Kontakt
                                </h6>
                                <ul>
                                    <li><i className="fas fa-map-marker-alt"></i>{this.props.result.contact_street}</li>
                                    <li><i className="fa fa-phone"></i><a href={`tel:${this.props.result.contact_phone}`}>{this.props.result.contact_phone}</a></li>
                                    {this.props.result.web != null ? (
                                        <li><i className="fa fa-link"></i><a href={`https://${this.props.result.web}`} target="_blank">{this.props.result.web}</a></li> ) : (<p></p>)
                                    }

                                </ul>
                                <div class="social_links">
                                    {this.props.result.facebook != null ? (
                                        <a href={`https://${this.props.result.facebook}`} class="facebook_link" target="_blank"><i
                                            class="fab fa-facebook-f"></i></a> ) : (<p></p>)
                                    }
                                    {this.props.result.instagram != null ? (
                                        <a href={`https://${this.props.result.instagram}`} class="instagram_link" target="_blank"><i
                                            class="fab fa-instagram"></i></a>
                                    ) : (<p></p>)
                                    }

                                </div>
                                <hr/>
                                {/*<h6 className="kontakt">*/}
                                    {/*Značky*/}
                                {/*</h6>*/}
                                {/*<ul>*/}
                                    {/*{this.props.tags.map(tag =>*/}
                                        {/*<li><i className="far fa-hand-point-right"></i> <a className="hovclick" onClick={()=> this.setittag(tag.title)}> {tag.title} </a></li>*/}
                                    {/*)}</ul>*/}
                                {/*<hr/>*/}
                                <h6 className="kontakt">
                                    Kategórie
                                </h6>

                                <ul>

                                    {this.props.categories.map(category =>
                                        <li><i className="far fa-hand-point-right"></i> <a className="hovclick" onClick={()=> this.setit(category.id)}>{category.title}</a></li>
                                        )}
                                    </ul>
                                <hr/>
                                {/*<h6 className="kontakt">*/}
                                {/*Značky*/}
                                {/*</h6>*/}
                                {/*<ul>*/}
                                {/*{this.props.tags.map(tag =>*/}
                                {/*<li><i className="far fa-hand-point-right"></i> <a className="hovclick" onClick={()=> this.setittag(tag.title)}> {tag.title} </a></li>*/}
                                {/*)}</ul>*/}
                                {/*<hr/>*/}

                                <h6 className="kontakt"> <i className="fa fa-share"></i>&nbsp;<a onClick={this.togshare}>Zdieľať</a></h6>
                                {this.state.share == true ?
                                <div className="share">{` https://vyhladavanie.apportal.sk/${this.props.result.id}`}</div>
                                    : null }

                                    <img src="https://mportalsystem2.btect.sk/images/1546468731.jpg" className="reklama124" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class Offers extends Component{
    constructor(props){
        super(props);

        this.state = {
            result:[],

        }

        axios.get('https://mportalsystem2.btect.sk/api/getlist/' + this.props.ide)
            .then(res => {
                const data = res.data[0];
                this.setState({ result: data.offers });
                console.log("dacooo");
                console.log(data);
                window.scrollTo(0,0);

            });

    }
    componentDidMount(){
        window.scrollTo(0,0);
    }
    formatDat = (date) =>{
        var date = new Date(date);

        return date.toLocaleDateString();
    }
    render(){
        return(
            <div>

                {Array.isArray(this.state.result) ? (
                    this.state.result.map(offer =>
                        <div>
                            <h3 className="offerhead">{offer.name}</h3>

                            {offer.image != null ?
                                <div className="cen">
                                    <br/>
                                        <img  src={`https://mportalsystem2.btect.sk${offer.image}`}/>
                                    <br/>
                                </div>
                            : null}

                            {/*<p className="offerparag">{offer.description}</p>*/}
                            { Parser(offer.description.toString()) }
                            <p className="offersale">Zľava: {offer.price}</p>
                            <p className="offerparag">Ponuka platí do: <u>{this.formatDat(offer.date_to)}</u></p>
                        </div>

                    )): (
                    <div>

                        Nič sa nenašlo
                    </div>
                )
                }
            </div>
        );
    }
}
class Description extends Component{
    constructor(props){
        super(props);

        this.state = {
            result:[],

        }


        axios.get('https://mportalsystem2.btect.sk/api/getlist/' + this.props.ide)
            .then(res => {
                const data = res.data[0];
                this.setState({ result: data.description });

                console.log(data);
                window.scrollTo(0,0);

            });

    }
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render(){
        return(
            <div>
                { Parser(this.state.result.toString()) }

            </div>
        );
    }

}
class OpenHours extends Component{
    constructor(props){
        super(props);

        this.state = {
            result:[],

        }

        axios.get('https://mportalsystem2.btect.sk/api/getlist/' + this.props.ide)
            .then(res => {
                const data = res.data[0];
                this.setState({ result: data.open });

                console.log(data);
                window.scrollTo(0,0);

            });

    }
    componentDidMount(){
        window.scrollTo(0,0);
    }

    formatDat = (date) =>{
        var date = new Date(date);

        return date.toLocaleDateString();
    }
    render(){
        return(
            <div>
                { Parser(this.state.result.toString()) }

            </div>
        );
    }
}

export default SearchDetailContent;